import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { StickyMobileCta } from "./StickyMobileCta";
import { BackToTop } from "@/components/ui/BackToTop";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
      <StickyMobileCta />
      <BackToTop />
      <div className="grain-overlay" aria-hidden="true" />
    </>
  );
}
